module.exports = __webpack_public_path__ + "static/media/dish5.6c60b8f0.jpg";